<template>
  <section class="update-balances-banner" v-if="showBanner">
    <div class="is-fixed">
      <div :class="{ 'delayed-show-bu': !disappear, 'slide-fade-ub': disappear }">
        <MessageView type="is-success" :closable="false">
          <template #header>
            <div class="is-flex is-flex-direction-row">
              <span class="has-text-black has-text-weight-light is-flex-grow-1 m-r-30">
                {{ text }}
              </span>
              <ProgressView
                v-if="canShowProgress"
                :value="percentValue"
                format="percent"
                type="is-success"
                :data-e2e="FinancialAccountCypressAttribute.views.BALANCES_PROGRESS_BANNER"
              />
            </div>
          </template>
        </MessageView>
      </div>
    </div>
    <div class="spacer"></div>
  </section>
</template>

<script>
import { FinancialAccountCypressAttribute } from '/@/modules/financialaccount/constants/FinancialAccountCypressAttribute';
import { FinancialAccountBalanceService } from '/@/modules/financialaccount/services/FinancialAccountBalanceService';
import EventBus from '/@/modules/core/app/helpers/EventBus';
import { FinancialAccountUpdateBalancesEvent } from '/@/modules/financialaccount/constants/FinancialAccountUpdateBalancesEvent';
import Lang from '/@/modules/core/app/services/Lang';
import { HasCurrentEstateMixin } from '/@/modules/core/app/mixins/HasCurrentEstateMixin';
import MessageView from '@/modules/core/ui/components/wrappers/MessageView.vue';
import ProgressView from '@/modules/core/ui/components/wrappers/ProgressView.vue';
import { HasContainerMixin } from '@/modules/core/app/mixins/HasContainerMixin';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'UpdateFinancialAccountBalancesBanner',
  mixins: [HasCurrentEstateMixin, HasContainerMixin],
  components: { MessageView, ProgressView },
  static: {
    FinancialAccountCypressAttribute
  },
  data() {
    return {
      increment: 0,
      percentValue: 0,
      showBanner: false,
      timeout: null,
      disappear: false,
      service: this.$resolve(FinancialAccountBalanceService)
    };
  },
  computed: {
    text() {
      if (!this.currentEstate.isClearEstate && this.currentEstate.jurisdiction.isInUnitedStates) {
        return Lang.t('financialaccount.updating-bank-accounts');
      }

      return this.completed
        ? Lang.t('financialaccount.update-complete')
        : Lang.t('financialaccount.updating-bank-accounts');
    },
    completed() {
      return this.percentValue === 100;
    },
    canShowProgress() {
      return this.currentEstate.isClearEstate && this.currentEstate.jurisdiction.isInUnitedStates;
    }
  },
  methods: {
    activateLoader() {
      this.timeout = setTimeout(
        () => {
          if (this.percentValue >= 95) {
            return;
          }
          this.increment += 1;
          this.percentValue =
            this.percentValue > 50 ? 50 + Math.log(this.increment) : this.increment;
          this.timeout && this.activateLoader();
        },
        this.percentValue > 50 ? 1 : 100
      );
    },
    deactivateLoader() {
      clearTimeout(this.timeout);
      this.percentValue = 100;
      setTimeout(() => {
        this.disappear = true;
        setTimeout(() => {
          this.showBanner = false;
        }, 4000);
      }, 2000);
    },
    onUpdateStart() {
      if (this.currentEstate.jurisdiction.isInCanada) {
        this.showBanner = true;
        this.disappear = false;
        setTimeout(() => {
          this.deactivateLoader();
        }, 5000);
        return;
      }

      this.increment = 0;
      this.percentValue = 0;
      this.showBanner = true;
      this.disappear = false;
      this.activateLoader();
    },
    onUpdateEnd() {
      this.deactivateLoader();
    }
  },
  created() {
    EventBus.listen(FinancialAccountUpdateBalancesEvent.START, this.onUpdateStart);
    EventBus.listen(FinancialAccountUpdateBalancesEvent.END, this.onUpdateEnd);
  },
  mounted() {
    this.service.startBackgroundSync();
  },
  beforeUnmount() {
    EventBus.destroy(FinancialAccountUpdateBalancesEvent.START, this.onUpdateStart);
    EventBus.destroy(FinancialAccountUpdateBalancesEvent.END, this.onUpdateEnd);
  }
};
</script>

<style scoped>
section.update-balances-banner {
  div.is-fixed {
    position: fixed;
    bottom: var(--ce-20px);
    margin-left: var(--ce-37px);
    width: calc(100% - var(--ce-315px));
    z-index: var(--ce-z-index-100);
  }

  .spacer {
    height: var(--ce-10px);
  }
}

section.update-balances-banner :deep(.message) {
  box-shadow: 1px 0 8px rgba(0, 0, 0, 0.08);
}

section.update-balances-banner :deep(.message .message-header) {
  border: var(--ce-green) var(--ce-1px) solid;
  border-width: var(--ce-1px) var(--ce-1px) var(--ce-1px) var(--ce-4px);
  background-color: var(--ce-white);
  border-radius: var(--ce-5px);
}

section.update-balances-banner :deep(.message .message-header > div) {
  width: 100%;
}

section.update-balances-banner :deep(.message .message-header span) {
  color: var(--ce-black);
}

section.update-balances-banner :deep(.message .message-header .progress-wrapper) {
  position: relative;
  top: var(--ce-2px);
  width: 100%;
  flex-shrink: 10000;
  transform: scaleY(0.7);
}
</style>
